import { AccordionHeader } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { AnimatePresence, motion } from 'motion/react';
import {
  SoundEffectCategory,
  SoundEffectDefinition,
  SOUND_EFFECT_CATEGORIES,
} from '@/features/remotion-editor/scripts/sound-effect-data';
import SoundEffectItem from './SoundEffectItem';
import { PlayerRef } from '@remotion/player';

interface SoundEffectCategorySectionProps {
  category: SoundEffectCategory;
  items: SoundEffectDefinition[];
  isExpanded: boolean;
  onToggle: () => void;
  playerRef: React.RefObject<PlayerRef | null>;
}

export default function SoundEffectCategorySection({
  category,
  items,
  isExpanded,
  onToggle,
  playerRef,
}: SoundEffectCategorySectionProps) {
  const t = useTranslations();
  const categoryInfo = SOUND_EFFECT_CATEGORIES[category];

  return (
    <div className="flex flex-col">
      <AccordionHeader
        size="lg"
        title={t(categoryInfo.labelKey)}
        isOpened={isExpanded}
        onClick={onToggle}
        isShowLabel
        labels={
          <span className="text-sys-cont-neutral-tertiary text-body-xsmall">
            ({items.length})
          </span>
        }
      />

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <div className="flex flex-col gap-2xs px-md py-xs">
              {items.map((item) => (
                <SoundEffectItem
                  key={item.id}
                  item={item}
                  playerRef={playerRef}
                />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
